/* eslint-disable */
import changeCase from 'change-object-case';
import moment from 'moment';
import React, { Component } from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux'
import { mapDispatch, navTo, numberWithCommas, setToken } from '../utils/util';
import { Button, Form, Glyphicon, FormGroup, ControlLabel, FormControl, Table, Modal } from 'react-bootstrap';
import { DateRangePicker, SingleDatePicker, DayPickerRangeController } from 'react-dates';
import FontAwesome from 'react-fontawesome';

import OzComponent from '../lib/OzComponent';
import Wrapper from './Wrapper';
import './Track.css';
import WhereField from './partials/WhereField';
import LeaderboardStats from './partials/LeaderboardStats';
import RegisterForm from './partials/RegisterForm';
import {
  login,
  register,
  fetchUser,
} from '../actions';


class Track extends OzComponent {

  static need = [
    ['user', fetchUser],
  ]

  state = {};

  register(e, values) {
    e.preventDefault();
    this.props.register(values)
      .then(resp => {
        if (!resp.error) {
          return this.props.login({
            username: values.username,
            password: values.password,
          });
        }
      })
      .then(resp => {
        if (!resp.error) {
          setToken(resp.token);
          this.props.fetchUser()
            .then(resp => {
              console.log('registered!');
              navTo('/p/' + values.username + '?tehelp=1');
            });
        }
      });
  }

  renderSpreadsheetBlurb() {
    return (
      <div className="spreadsheet-blurb">
        <div className="header">Have a spreadsheet? (BETA)</div>
        <p><b>Do you track your escapes in a spreadsheet?</b> You can import it into EscapeSpy! Use our tool to easily track dozens or hundreds of escapes that you already have in a spreadsheet.</p>
        <Link to="/sh"><Button bsSize="lg">Import Your Spreadsheet</Button></Link>
      </div>
    )
  }

  renderBlurbForm() {
    let user = this.props.user;
    let isLoggedIn = user && user.profile;

    return (
      <div className="blurb-and-form">
        <div className="blurb">
          <div className="blurb-copy">
            <p className="top-line">Create a profile to start tracking your escapes.</p>
            <ul>
              <li>
                <div className="big"><b>Track</b> your escapes</div>
                <div className="small">View your performance stats, including teams, times, escape rate, photos, and more.</div>
              </li>

              <li>
                <div className="big"><b>Discuss</b> rooms</div>
                <div className="small">Chat and compare your experience with others who completed the same room.</div>
              </li>

              <li>
                <div className="big"><b>Rank</b> your favorites</div>
                <div className="small">Rate and review different rooms and create a list of your favorite escapes.</div>
              </li>
            </ul>
          </div>
        </div>
        <div className="form">
          {!isLoggedIn && <RegisterForm
            values={{}}
            errors={this.props.errors.register}
            buttonText="Track Your Escapes"
            onSubmit={(e, values) => this.register(e, values)}
           />}
          {isLoggedIn && <div className="go-to-profile">
          <p>Go to you profile to track your escapes</p>
          <Link to={'/p/' + user.profile.username}><Button bsSize="lg" bsStyle="primary">Go To Profile</Button></Link>
          </div>}
          {/*this.renderSpreadsheetBlurb()*/}
        </div>
      </div>
    )
  }

  render() {
    return (
      <Wrapper className="Track" title="Track Your Escapes">
        {this.renderBlurbForm()}
      </Wrapper>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.user,
    errors: state.errors,
  };
}

function mapDispatchToProps(dispatch) {
  return mapDispatch(dispatch, {
    login,
    register,
    fetchUser,
  });
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Track);



/** WEBPACK FOOTER **
 ** ./src/components/Track.js
 **/